import React from "react";
import withRouter from "../../Components/Common/withRouter";
import Icon from "Components/Icons/Icon";

const ParticlesAuth = ({ children }: any) => {
  return (
    <React.Fragment>
      <div className="auth-page-wrapper">
        <div className="" id="auth-particles">
          <Icon name="AuthBg" className="auth-bg-container1" />
          <div className="auth-content1">{children}</div>
        </div>
      </div>
    </React.Fragment>
  );
};

export default withRouter(ParticlesAuth);
